import { Component, Input } from '@angular/core';

@Component({
    selector: 'support-infoBox',
    template: `
        <div class="supportInfoBox" [ngClass]="cssClass">
            <div class="supportInfoBox_container areaContainer">
                <div class="supportInfoBox_header">
                    <ng-content boxHeader select="[boxHeader]"> </ng-content>
                </div>
                <div class="supportInfoBox_info">
                    <ng-content boxBody select="[boxBody]"> </ng-content>
                </div>
                <div class="supportInfoBox_footer">
                    <ng-content boxFooter select="[boxFooter]"></ng-content>
                </div>
            </div>
        </div>
    `,
    standalone: false
})
export class SupportInfoBoxComponent {
    @Input()
    cssClass: string;
}
